var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"merchant-list"},[_c('GlobalInfoBar',{attrs:{"title":"商家列表","content":"管理已合作的回收商家，查看或处理已发送的合作申请"}}),_c('GlobalChunkNo',{attrs:{"icon":"search","title":"筛选查询"}},[_c('div',{attrs:{"slot":"filter"},slot:"filter"},[_c('Form')],1),_c('Table')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }